var exports = {
  "d": "centeredFooterItem__KrfxOk",
};

module.exports = exports;
